import {Box, Flex, Icon, Image, Text} from '@chakra-ui/react'
import {CommonColors} from '@utils/CommonStyles'
import {ReactComponent as ArrowRightIcon} from '@assets/svgs/learn/arrow_right_2.svg'
import Paraphrasing from '@assets/images/gym/paraphrasing.png'
import Brainstorming from '@assets/images/gym/brainstorming.png'
import {PATH} from '@utils/Const'
import {useNavigate} from 'react-router-dom'

const dataLearning = [
  {
    title: 'Paraphrasing',
    description:
      'Học cách diễn đạt ý tưởng bằng nhiều cách khác nhau, giúp bạn tăng điểm Lexical Resources và Grammar',
    image: Paraphrasing,
    path: PATH.PARAPHRASE_ROOM,
    isComingSoon: false,
  },
  {
    title: 'Brainstorming',
    description:
      'Luyện tập tư duy phát triển ý để không còn ấp úng, tăng điểm Fluency',
    image: Brainstorming,
    isComingSoon: true,
  },
]

const LearningCard = ({item}: {item: any}) => {
  const navigate = useNavigate()

  const handleNavigate = () => {
    if (item.path) {
      navigate(item.path)
    }
  }

  return (
    <Flex
      flex={1}
      p={{base: '16px', md: '32px'}}
      gap={{base: '16px', md: '24px', xl: '32px'}}
      borderRadius={'16px'}
      bg={CommonColors.white}
      border={'1px solid #EFEFEF'}
      cursor={item.path ? 'pointer' : 'not-allowed'}
      onClick={handleNavigate}>
      <Box>
        <Text
          fontSize={{base: '18px', md: '18px', xl: '24px'}}
          fontWeight={600}>
          {item.title}
        </Text>
        <Text
          as={'span'}
          fontSize={{base: '14px', md: '14px', xl: '18px'}}
          color={'#7C7C7C'}>
          {item.isComingSoon ? '(COMING SOON)' : ''}
        </Text>
        <Text
          fontSize={{base: '14px', md: '14px', xl: '16px'}}
          color={'#7C7C7C'}
          mt={'16px'}>
          {item.description}
        </Text>
      </Box>
      <Flex
        flexShrink={0}
        flexDirection={'column'}
        justifyContent={'space-between'}
        gap={'16px'}
        alignItems={'center'}>
        <Image
          src={item.image}
          w={{base: '40px', md: '40px', xl: '60px'}}
          objectFit={'contain'}
          flexShrink={0}
        />
        <Icon as={ArrowRightIcon} w={'24px'} h={'24px'} />
      </Flex>
    </Flex>
  )
}

const ListLearningCard = () => {
  return (
    <Flex
      gap={{base: '16px', md: '32px'}}
      flexDirection={{base: 'column', md: 'row'}}>
      {dataLearning.map((item, index) => (
        <LearningCard key={index} item={item} />
      ))}
    </Flex>
  )
}

export default ListLearningCard
